import React from 'react';
import Navbar from '../Shared/Navbar';
import img404 from '../../assets/404.svg';

const NotFound = () => {
    return (
        <div className='w-full'>
            <Navbar />
            <div className='text-center mt-2 mb-5 pb-5 mx-5'>
                <h1 className='text-gray-600 text-4xl font-bold mt-8'>Oopss! Sorry for that...</h1>
                <img className='w-1/2 mx-auto d-block my-4' src={img404} alt="404 image" />
                <h1 className='text-gray-600 text-4xl font-bold my-4'>Page Not Found</h1>
                <p className='text-xl font-semibold'>We're sorry, the page you requested could not be found. <br></br> Please go back to the homepage.</p>
            </div>
        </div>
    );
};

export default NotFound;